import {withBemMod} from "@bem-react/core";
import React, {ChangeEvent, useState} from "react";
import {IInputProps} from "../Input";
import {cnInput} from "../index";
import {INPUT_TYPE_PASSWORD} from "../../../constants";
import {Svg} from "../../Svg";

export interface IInputPasswordProps<HTMLInputElement> extends IInputProps<HTMLInputElement> {
    value?: string;
    name?: string;
    onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
}

const InputPassword: React.FC<IInputPasswordProps<HTMLInputElement>> = ({className, onChange, value, name, disabled}) => {
    const [focus, setFocus] = useState<boolean>(false);
    const [showValue, setShowValue] = useState<boolean>(false);
    const toggleShowText = () => {
        setShowValue(!showValue);
    }

    return (
        <div className={cnInput('Wrapper')}>
        <input
            className={cnInput({focus: focus}, [className])}
            type={showValue ? 'text' : 'password'}
            value={value}
            name={name}
            disabled={disabled}
            onFocus={() => {setFocus(true)}}
            onBlur={() => {setFocus(false)}}
            onChange={onChange}
        />
            <Svg icon={showValue ? 'eyeHide' : 'eye'}
                 className={cnInput('Icon', {type: 'password'})}
                 onClick={toggleShowText}
            />
        </div>
    );
};

export const withInputPassword = withBemMod<IInputPasswordProps<HTMLInputElement>>(
    cnInput(),
    { type: INPUT_TYPE_PASSWORD },
    () => InputPassword
);